import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IFermenterVM } from 'app/models/fermenter';

/**
 * Stylised Grainfather Conical Fermenter graphic with a fill level.
 * Mirrors the keg SVG components: `item.amount / item.size` drives a beverage-
 * coloured fill that grows upward, clipped to the vessel interior (cylinder + cone).
 * The black insulation jacket is drawn semi-transparent so the liquid level stays
 * readable (function over photo-realism).
 */
@Component({
  selector: 'app-fermenter-grainfather-svg',
  templateUrl: './fermenter-grainfather-svg.component.svg',
  styleUrls: ['./fermenter-grainfather-svg.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class FermenterGrainfatherSvgComponent implements OnChanges {

  @Input() item!: IFermenterVM;

  /** Fillable interior spans y = [topY .. bottomY]; fill grows upward from bottomY. */
  private readonly topY = 74;
  private readonly bottomY = 256;

  height = 0;
  y = this.bottomY;

  ngOnChanges(_changes: SimpleChanges): void {
    if (!this.item) return;
    const size = this.item.size ?? 0;
    const amount = this.item.amount ?? 0;
    const totHeight = this.bottomY - this.topY;
    const factor = size <= 0 || amount <= 0 ? 0 : Math.min(amount / size, 1);
    this.height = totHeight * factor;
    this.y = this.bottomY - this.height;
  }
}
